import { updateUrlWithNewSearchParameter } from 'src/utils/router'
import { setSharedCurrencyAction } from 'src/redux/actions'

export const setSharedCurrency =
  (data, noUrlUpdate = false) =>
  dispatch => {
    dispatch(setSharedCurrencyAction(data))
  }
